import axios from "axios";

// Base URL for your API
const baseURL = "https://apisrightride.nemtbusiness.com/api";

// Axios instance for JSON requests
export const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json", // Default to JSON
  },
});

// Axios instance for multipart requests (e.g., file uploads)
export const apiMultipart = axios.create({
  baseURL,
  headers: {
    "Content-Type": "multipart/form-data", // For file uploads
  },
});

// Function to attach tokens to requests
const attachToken = (config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`; // Attach token to request headers
  }
  return config;
};

// Request interceptors for adding tokens
api.interceptors.request.use(attachToken);
apiMultipart.interceptors.request.use(attachToken);

// Response interceptor for token refresh in case of expired token (401 error)
const responseInterceptor = async (error) => {
  const originalRequest = error.config;

  // Check if the response status is 401 (Unauthorized)
  if (error.response?.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;

    // Get the refresh token
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      window.location.href = "/login"; // Redirect to login if no refresh token
      return Promise.reject(error);
    }

    try {
      // Request a new access token using the refresh token
      const response = await axios.post(`${baseURL}/auth/refresh-token`, {
        refreshToken,
      });

      const newAccessToken = response.data.accessToken;
      const newRefreshToken = response.data.refreshToken;

      // Store the new tokens in localStorage
      localStorage.setItem("accessToken", newAccessToken);
      localStorage.setItem("refreshToken", newRefreshToken);

      // Set the new access token to headers for future requests
      api.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`;
      originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

      // Retry the original request with the new access token
      return api(originalRequest);
    } catch (err) {
      // Clear the tokens and redirect to login if refreshing fails
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      window.location.href = "/login";
      return Promise.reject(err);
    }
  }

  return Promise.reject(error);
};

// Apply the response interceptor to both instances
api.interceptors.response.use((res) => res, responseInterceptor);
apiMultipart.interceptors.response.use((res) => res, responseInterceptor);

// Export both instances for use in your app
export default { api, apiMultipart };
